import { addYears, format, subYears } from 'date-fns';
import * as React from 'react';

import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';

interface DatePickerProps {
  date: string | null | undefined;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  date,
  onChange,
  placeholder = 'Pick a date',
  className,
  disabled = false,
}) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          disabled={disabled}
          className={cn(
            'h-auto p-0 font-normal justify-start hover:bg-transparent hover:text-blue-600 text-left rounded-md',
            !date && 'text-slate-400',
            className,
          )}
        >
          {date ? format(new Date(date), 'MMM d, yyyy') : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date ? new Date(date) : undefined}
          onSelect={(newDate) => onChange(newDate || null)}
          captionLayout="dropdown"
          endMonth={addYears(new Date(), 5)}
          startMonth={subYears(new Date(), 5)}
        />
      </PopoverContent>
    </Popover>
  );
};
